export default {"src":"/_next/static/media/settings.cc20c816.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};